import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "gatsby-plugin-react-i18next";
import InputStepper from "components/Design/Input/InputStepper";

// constants
import { MAX_ROOM } from "store/constants/rooms";

import "./style.less";
import {
  JAKARTA_LOCATION,
  KOMODO as KOMODO_LOCATION,
} from "store/constants/hotel";
import { JAKARTA, KOMODO } from "store/constants/destinationInBlocks";

function RoomGuestControl({
  availableRooms,
  onChange,
  rooms,
  children,
  adults,
  infants,
  location,
  ...props
}) {
  const onValueChange = (name) => (value) => {
    onChange({ [name]: value });
  };
  const { t } = useTranslation("homepage");
  const onRoomChange = (value) => {
    if (rooms < value && adults < value) {
      onChange({
        adults: value,
        rooms: value,
      });

      return;
    }

    onChange({
      rooms: value,
    });
  };

  return (
    <div
      className="guest-select relative w-full md:bg-white md:shadow-date-tooltip mt-15 py-12 px-20 md:p-12"
      {...props}
      autoFocus>
      <div className="guest-select-dropdown-arrow hidden md:block" />
      <div className="block w-full mb-24">
        <InputStepper
          name="rooms"
          label={t("RoomLabel")}
          error={rooms > availableRooms}
          max={MAX_ROOM}
          min={1}
          value={rooms}
          onChange={onRoomChange}
        />
      </div>
      <div className="block w-full mb-24">
        <InputStepper
          label={t("AdultWithoutCount")}
          min={rooms}
          value={adults}
          onChange={onValueChange("adults")}
        />
      </div>
      <div className="block w-full mb-24">
        <InputStepper
          onChange={onValueChange("children")}
          label={t("ChildWithoutCount")}
          description={
            location === JAKARTA_LOCATION || location === JAKARTA
              ? t("5 - 11 Years Old")
              : t("4 - 11 Years Old")
          }
          value={children}
        />
      </div>
      {(location === KOMODO || location === KOMODO_LOCATION) && (
        <div className="block w-full mb-24">
          <InputStepper
            label={t("InfantWithoutCount")}
            value={infants ?? 0}
            onChange={onValueChange("infants")}
          />
        </div>
      )}
    </div>
  );
}

RoomGuestControl.defaultProps = {
  availableRooms: MAX_ROOM,
};

RoomGuestControl.propTypes = {
  availableRooms: PropTypes.number,
  onChange: PropTypes.func,
  rooms: PropTypes.number,
  children: PropTypes.number,
  adults: PropTypes.number,
  infants: PropTypes.number,
};

export default RoomGuestControl;
